<div class="programming-panel">
  <!-- Theme Toggle -->
  <div class="nav-item theme-toggle-container">
    <app-theme-toggle></app-theme-toggle>
  </div>

  <!-- Font Selector - Allows selecting font family and size for testing typography system -->
  <div class="font-selector-section">
    <div class="font-selector-header">
      <span class="font-label b-semibold">{{ 'programmingPanel.fontFamily' | t }}</span>
    </div>
    <div class="font-controls">
      <div class="font-family-picker">
        <label class="picker-label sub">{{ 'programmingPanel.font' | t }}</label>
        <select [value]="ui.fontFamily()" (change)="onFontFamilyChange($event)" class="font-select">
          <option value="font-crimson">Crimson (Serif)</option>
          <option value="font-system">Sistema (Sans-serif)</option>
          <option value="font-raleway">Raleway (Sans-serif)</option>
          <option value="font-serif">Serif Clásico</option>
          <option value="font-sans">Sans-serif</option>
          <option value="font-monospace">Monospace</option>
        </select>
      </div>
      <div class="font-size-picker">
        <label class="picker-label sub">{{ 'programmingPanel.fontSize' | t }}</label>
        <select [value]="ui.fontSize()" (change)="onFontSizeChange($event)" class="size-select">
          <option value="font-size-xs">{{ 'programmingPanel.extraSmall' | t }} (75%)</option>
          <option value="font-size-sm">{{ 'programmingPanel.small' | t }} (87.5%)</option>
          <option value="font-size-md">{{ 'programmingPanel.normal' | t }} (100%)</option>
          <option value="font-size-lg">{{ 'programmingPanel.large' | t }} (112.5%)</option>
          <option value="font-size-xl">{{ 'programmingPanel.extraLarge' | t }} (125%)</option>
          <option value="font-size-xxl">{{ 'programmingPanel.veryLarge' | t }} (150%)</option>
        </select>
      </div>
    </div>
  </div>

  <!-- UI Settings -->
  <div class="ui-settings-section">
    <div class="ui-settings-header">
      <span class="ui-label b-semibold">UI Settings:</span>
    </div>
    <div class="ui-controls">
      <div class="max-materials-picker">
        <label class="picker-label sub">{{ 'programmingPanel.visibleMaterialsInCards' | t }}</label>
        <select [value]="ui.maxDisplayMaterials()" (change)="onMaxDisplayMaterialsChange($event)" class="materials-select">
          <option [value]="2">2</option>
          <option [value]="3">3</option>
          <option [value]="4">4</option>
          <option [value]="5">5</option>
          <option [value]="6">6</option>
          <option [value]="8">8</option>
          <option [value]="10">10</option>
        </select>
      </div>
    </div>
  </div>

  <div class="time-picker-section">
    <div class="time-picker-header">
      <span class="time-label b-semibold">{{ 'programmingPanel.currentDateTimeForTesting' | t }}</span>
      <button class="reset-time-btn sub" (click)="resetToCurrentTime()">{{ 'programmingPanel.useRealDateTime' | t }}</button>
    </div>
    <div class="datetime-picker">
      <div class="day-picker">
        <label class="picker-label sub">{{ 'programmingPanel.day' | t }}</label>
        <select [value]="ui.currentDayOfWeek()" (change)="onDayChange($event)" class="day-select">
          <option value="0">{{ 'days.sunday' | t }}</option>
          <option value="1">{{ 'days.monday' | t }}</option>
          <option value="2">{{ 'days.tuesday' | t }}</option>
          <option value="3">{{ 'days.wednesday' | t }}</option>
          <option value="4">{{ 'days.thursday' | t }}</option>
          <option value="5">{{ 'days.friday' | t }}</option>
          <option value="6">{{ 'days.saturday' | t }}</option>
        </select>
      </div>
      <div class="time-picker">
        <label class="picker-label sub">{{ 'programmingPanel.time' | t }}</label>
        <input type="time" [value]="ui.currentTimeString()" (change)="onTimeChange($event)" class="time-input">
      </div>
    </div>
    <div class="current-datetime-display">
      <span class="sub">{{ ui.currentTimeDisplay() }}</span>
    </div>
    <div class="programming-mode-indicator">
      <span class="programming-badge sub">🧪 {{ 'programmingPanel.devModeActive' | t }}</span>
    </div>
  </div>
</div>